<template>
    <div class="ct-map-geo-data-map" v-if="errorMessages.length === 0">
        <MapboxBanner v-if="!screenIsDesktop" v-bind="bannerProps" />
        <MapboxMap class="ct-map-geo-data-map__container"
            v-bind="{ id: 'geoDataMap', configuration }" @load="onMapLoad">

            <MapboxSource v-bind="baseConfigurations.sources.polygons" :key="sourceKeys.polygons">
                <MapboxLayer v-bind="baseConfigurations.layers.polygons" />
                <MapboxLayer v-bind="baseConfigurations.layers.polygonOutline" />
            </MapboxSource>
            <MapboxSource v-bind="baseConfigurations.sources.polygonCentroids" :key="sourceKeys.polygonCentroids">
                <MapboxLayer v-bind="baseConfigurations.layers.polygonDiamonds" />
            </MapboxSource>
            <MapboxSource v-bind="baseConfigurations.sources.points" :key="sourceKeys.points">
                <MapboxLayer v-bind="baseConfigurations.layers.points" />
            </MapboxSource>
            <MapboxLegend :translations="translations" :showPolygonDiamond="showPolygonDiamondLegend" />
            <MapboxPopup v-bind="{
                configuration: popupConfig,
                lngLat: popUpLngLat,
                title: iccaInfo.latin_name
            }" @close="closePopup">
                <MapboxIccaInfo v-bind="{ iccaInfo, translations, sitePath }" />
            </MapboxPopup>
            <MapboxBanner v-if="screenIsDesktop" v-bind="bannerProps" />
        </MapboxMap>
        <MapboxDisclaimer v-bind="{ translations }" />
    </div>
    <BannerWarning v-else>
        <template #left>{{ errorMessagesTranslation.error_occurred }}</template>
        <template #right>
            <ol>
                <li :key="`errorMsg${index}`" v-for="(errorMessage, index) in errorMessages" v-text="errorMessage" />
            </ol>
        </template>
    </BannerWarning>
</template>

<script setup>
import { inject } from 'vue'
import BannerWarning from "@components/Banner/Warning"
import MapboxMap from "@components/Mapbox/Map"
import MapboxSource from "@components/Mapbox/Source"
import MapboxLayer from "@components/Mapbox/Layer"
import MapboxPopup from "@components/Mapbox/Popup"
import MapboxBanner from "@components/Mapbox/Banner"
import MapboxLegend from "@components/Mapbox/Legend"
import MapboxIccaInfo from "@components/Mapbox/IccaInfo"
import MapboxDisclaimer from "@components/Mapbox/Disclaimer"
import { useGeoDataMap } from '@composables/useGeoDataMap'
import { useStore } from "@app/javascript/store/store"

const props = defineProps({
    geoJson: {
        type: Object,
        default: null
    },
    sitePath: {
        type: String,
        required: true,
    },
    dataCollectionTermsLink: {
        type: String,
        required: true
    },
    privacyPolicyLink: {
        type: String,
        required: true
    },
    translations: {
        type: Object,
        default: () => ({})
    }
})

const {
    screenIsDesktop,
    errorMessages,
    errorMessagesTranslation,
    configuration,
    sourceKeys,
    popupConfig,
    baseConfigurations,
    bannerProps,
    popUpLngLat,
    iccaInfo,
    showPolygonDiamondLegend,
    onMapLoad,
    closePopup
} = useGeoDataMap(props, { env: inject('$env'), store: useStore() })
</script>
<style lang="postcss" scoped>
.ct-map-geo-data-map {
    @apply flex flex-col mb-2;

    &__container {
        @apply relative border-2 border-theme-primary h-[45rem] lg:h-[51.875rem];
    }
}
</style>
